import Clarity from '@microsoft/clarity';

export function initClarity() {
  Clarity.init('rwcq1x2ucv');
}
